export default {
  en: {
    pricing_overview: 'Pricing Overview',
    meta_pricing_description:
      'Discover our pricing plans for ChronoFox. Choose the right plan for your needs and start your free trial today.',
    meta_keywords:
      'ChronoFox, Pricing Overview, Subscriptions, Freelancer, Companies, ChronoFox Time Tracking, ChronoFox Subscriptions',
  },
  de: {
    pricing_overview: 'Preisübersicht',
    meta_pricing_description:
      'Entdecke unsere Abos für ChronoFox. Wähle den richtigen Plan für deine Bedürfnisse und starte noch heute deine kostenlose Testversion.',
    meta_keywords:
      'ChronoFox, Preisübersicht, Abonnements, Freelancer, Unternehmen, ChronoFox Zeiterfassung, ChronoFox Abonnements',
  },
};
